import { httpService, urlService } from 'core-utilities';
import { DeviceMeta, FormEvents, Endpoints, EnvironmentUrls } from 'Roblox';
import premiumUrlConstants from '../constants/PremiumUrlConstants';
import premiumConstants from '../constants/PremiumConstants';

const { getAbsoluteUrl } = Endpoints;
const { isIosApp, isAndroidApp, isUWPApp, isAmazonApp } = DeviceMeta();

const getSubscriptionPlans = params => {
  const config = premiumUrlConstants.getSubscriptionPlansConfig();
  return httpService.get(config, params);
};
const getUserPremiumStatus = () => {
  const config = premiumUrlConstants.getUserStatusConfig();
  return httpService.get(config);
};

const getProductPolicy = () => {
  const config = premiumUrlConstants.getProductPolicyConfig();
  return httpService.get(config);
};

function getPaymentUrl(product, page) {
  if (!product) {
    return '';
  }

  let params = {};
  let paymentUrl = '';
  if (isAndroidApp) {
    params.id = product.mobileProductId.toLowerCase();
    params.recurring =
      product.premiumFeatureTypeName === 'Subscription' &&
      !product.mobileProductId.endsWith('OneMonth');
    paymentUrl = premiumUrlConstants.getMobilePaymentUrl(urlService.composeQueryString(params));
  } else if (isUWPApp || isAmazonApp) {
    params.id = product.mobileProductId.toLowerCase();
    paymentUrl = premiumUrlConstants.getMobilePaymentUrl(urlService.composeQueryString(params));
  } else if (isIosApp) {
    params.id = product.mobileProductId;
    paymentUrl = premiumUrlConstants.getMobilePaymentUrl(urlService.composeQueryString(params));
  } else {
    params = {
      ap: product.productId,
      page
    };
    paymentUrl = premiumUrlConstants.getDesktopPaymentUrl(urlService.composeQueryString(params));
  }
  return getAbsoluteUrl(paymentUrl);
}

const getSubscriptionPageUrl = () => {
  return getAbsoluteUrl(premiumUrlConstants.urls.subscribePageUrl);
};

const getTermsPageUrl = () => {
  return getAbsoluteUrl(premiumUrlConstants.urls.termsUrl);
};

const getPrivacyPageUrl = () => {
  return getAbsoluteUrl(premiumUrlConstants.urls.privacyUrl);
};

const getBillingSettingUrl = () => {
  return getAbsoluteUrl(premiumUrlConstants.urls.billingSettingUrl);
};

const getPremiumCatalogUrl = () => {
  return getAbsoluteUrl(premiumUrlConstants.urls.catalogUrl);
};

const getPremiumGameUrl = () => {
  return getAbsoluteUrl(premiumUrlConstants.urls.premiumGameUrl);
};

const getCurrentPlatform = () => {
  let deviceType = '';
  if (DeviceMeta().isAndroidApp) {
    deviceType = premiumConstants.platformType.isAndroidApp;
  } else if (DeviceMeta().isAmazonApp) {
    deviceType = premiumConstants.platformType.isAmazonApp;
  } else if (DeviceMeta().isIosApp) {
    deviceType = premiumConstants.platformType.isIosApp;
  } else if (DeviceMeta().isUWPApp) {
    deviceType = premiumConstants.platformType.isUwpApp;
  } else if (DeviceMeta().isXboxApp) {
    deviceType = premiumConstants.platformType.isXboxApp;
  } else {
    deviceType = premiumConstants.platformType.isDesktop;
  }
  return deviceType;
};

const sendInteractionClickEvent = (context, input, pid, fromPid, field) => {
  if (FormEvents) {
    FormEvents.SendInteractionClick(context, field, input, {
      pid,
      from_pid: fromPid
    });
  }
};

const getMembershipNameLocaleKey = subscriptionType => {
  switch (subscriptionType) {
    case premiumConstants.subscriptions.RobloxPremium450:
    case premiumConstants.subscriptions.RobloxPremium450OneMonth:
      return 'Label.RobloxPremium450';

    case premiumConstants.subscriptions.RobloxPremium1000:
    case premiumConstants.subscriptions.RobloxPremium1000OneMonth:
      return 'Label.RobloxPremium1000';

    case premiumConstants.subscriptions.RobloxPremium2200:
    case premiumConstants.subscriptions.RobloxPremium2200OneMonth:
      return 'Label.RobloxPremium2200';
    default:
      return 'Label.RobloxPremium';
  }
};

export default {
  getSubscriptionPlans,
  getUserPremiumStatus,
  getProductPolicy,
  getPaymentUrl,
  getSubscriptionPageUrl,
  getTermsPageUrl,
  getPrivacyPageUrl,
  getBillingSettingUrl,
  getPremiumCatalogUrl,
  getPremiumGameUrl,
  getCurrentPlatform,
  sendInteractionClickEvent,
  getMembershipNameLocaleKey
};
